import store from '../../store';
import { dbGetAllByIndex, dbPut } from './db';
import { notifyReviewStore } from './events';
import { IEditLogEntry } from './types';

/** Name of the signed-in Cognito user, stored with every log entry. */
export const currentActor = (): string | null => {
    try {
        return store.getState().auth?.data?.name || null;
    } catch (e) {
        return null;
    }
};

/** Append an entry to the local edit log. Never throws — logging must not break editing. */
export const addEditLog = async (entry: { batchId: string; fileId?: string; action: string; details?: Record<string, unknown> }) => {
    const record: Omit<IEditLogEntry, 'id'> = { ...entry, ts: Date.now(), actor: currentActor() };
    try {
        await dbPut('logs', record);
        notifyReviewStore();
    } catch (e) {
        console.warn('Failed to write print review log', e);
    }
};

export const getFileLogs = async (fileId: string) =>
    (await dbGetAllByIndex<IEditLogEntry>('logs', 'fileId', fileId)).sort((a, b) => a.ts - b.ts);

export const getBatchLogs = async (batchId: string) =>
    (await dbGetAllByIndex<IEditLogEntry>('logs', 'batchId', batchId)).sort((a, b) => a.ts - b.ts);

export const downloadBatchLogs = async (batchId: string) => {
    const logs = await getBatchLogs(batchId);
    const blob = new Blob([JSON.stringify({ batchId, exportedAt: new Date().toISOString(), logs }, null, 2)], {
        type: 'application/json',
    });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `print-set-${batchId}-log.json`;
    a.click();
    setTimeout(() => URL.revokeObjectURL(url), 1000);
};
